import React from "react";
import { Typography } from "@mui/material";
import { ButtonBlue } from "../buttons";
import arrowSvg from '../../assets/svgs/arrow.svg';

const CompleteChapterButton = ({ onClick, disabled }) => {

    return <ButtonBlue onClick={onClick} disabled={disabled} sx={{ my: 2 }}>
        <Typography
            sx={{
                fontWeight: '700',
                fontFamily: '"Quicksand", sans-serif',
                fontSize: { xs: '1em', sm: '1.2em', md: '1.6em', lg: '1.8em' },
                zIndex: 2,
            }}
        >
            {'Continue'}
        </Typography>
        <img
            style={{
                width: '15%',
                maxWidth: '100%',
                marginTop: '5px',
                height: 'auto',
                zIndex: 2,
            }}
            src={arrowSvg}
            alt=""
        />

    </ButtonBlue>
}

export default CompleteChapterButton;